__turbopack_context__.v({
  "active": "schedule-module-scss-module__yfm_Sq__active",
  "nowPlayingSpan": "schedule-module-scss-module__yfm_Sq__nowPlayingSpan",
  "scheduleItemDesc": "schedule-module-scss-module__yfm_Sq__scheduleItemDesc",
  "scheduleItemTitle": "schedule-module-scss-module__yfm_Sq__scheduleItemTitle",
  "scheduleLineup": "schedule-module-scss-module__yfm_Sq__scheduleLineup",
  "scheduleLineupHeader": "schedule-module-scss-module__yfm_Sq__scheduleLineupHeader",
  "scheduleNowPlaying": "schedule-module-scss-module__yfm_Sq__scheduleNowPlaying",
  "scheduleTime": "schedule-module-scss-module__yfm_Sq__scheduleTime",
});
